<template>
    <v-card elevation="3" min-width="540px">
        <v-card-title>
            <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                <div class="text-black d-flex flex-column align-center">
                    <v-img :src="logo" :width="75" draggable="false"/>
                    <v-img :src="logoText" :width="100" draggable="false"/>
                </div>
            </router-link>
        </v-card-title>
        <v-card-title>Reset your password</v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="formData.valid" validate-on="input lazy" @submit.prevent="submit">
                <v-text-field
                    v-model="formData.code"
                    autocomplete="one-time-code"
                    label="6-digit code"
                    inputmode="numeric"
                    maxlength="6"
                    :rules="codeRules"
                    @input="onCodeInput"
                />
                <v-text-field v-model="formData.password" :rules="[vRules.required, vRules.minLength(8)]"
                              autocomplete="new-password" label="Password" type="password"/>
                <v-text-field v-model="formData.password_confirmation"
                              :rules="[vRules.required, vRules.minLength(8), vRules.sameAs(formData.password, 'password')]"
                              autocomplete="new-password" label="Confirm Password" type="password"/>

                <v-btn :disabled="!formData.valid || processing" :loading="processing" block color="primary"
                       @click="submit">Save
                </v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script setup>
import router from "@/router";
import {reactive, ref} from 'vue'
import {send} from "@/composables/apiClient";
import {showApiError} from "@/composables/useApiError";
import logo from "@/assets/images/logo-1.png";
import logoText from "@/assets/images/logo-text.png";
import {useNavigation} from "@/composables/globals";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore()
const processing = ref(false)
const {navigateTo} = useNavigation()
const formData = reactive({
    valid: false,
    code: null,
    password: null,
    password_confirmation: null,
})

const codeRules = [
    v => !!v || 'Enter the code we emailed you',
    v => /^\d{6}$/.test(v || '') || 'Enter the 6-digit numeric code',
]

const onCodeInput = () => {
    if (formData.code) {
        formData.code = formData.code.replace(/\D/g, '').slice(0, 6)
    }
}

const submit = () => {
    send('put', `reset-password/${router.currentRoute.value.params.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message)
            navigateTo('login')
        })
        .catch(function (errorResponse) {
            // Bugfix: previous catch referenced an undeclared `errors`
            // ref and then unconditionally showed "Something went wrong"
            // even after successfully parsing a server error message.
            // Now: validation errors get their own snackbars, everything
            // else routes through the throttle-aware helper so 429 shows
            // a retry window.
            const validationErrors = errorResponse?.response?.data?.errors;
            if (validationErrors && typeof validationErrors === 'object') {
                Object.keys(validationErrors).forEach((key) => {
                    snackbar.showSnackbar(validationErrors[key][0], 'error');
                });
                return;
            }
            showApiError(snackbar, errorResponse, "Couldn't reset your password. Please try again.");
        })
}
</script>

<style scoped>

</style>
